import React, { FC } from 'react';

import { Options } from 'pages/MainPage/blocks/TariffCardBlock/components/Options';
import { OptionsV2 } from 'pages/MainPage/blocks/TariffCardBlock/components/OptionsV2';
import { IOptions } from 'pages/MainPage/blocks/TariffCardBlock/types';

const optionsComponentMap: Record<string, React.ComponentType<IOptions>> = {
  cashback: OptionsV2,
};

export const OptionsContainer: FC<{ options: IOptions | null | undefined }> = ({ options }) => {
  if (!options) return null;

  const Component =
    options.variant && optionsComponentMap[options.variant] ?
      optionsComponentMap[options.variant]
    : Options;

  return <Component {...options} />;
};
